<script>
export default {
  methods: {},
  props: ["component", "handler"],
  translate25Context: 'troubleshooting'
};
</script>

<template>
  <f-list-item icon="fa6-circle-question" variant="default left"
    href="#/troubleshooting">{{ $vt('Help') }}</f-list-item>
</template>

<style lang="scss"></style>